'use strict';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var tokenStorage = require("./tokenStorage.js");
var RequestClient = require("./RequestClient.js");
var getName = function(id) {
    return id.split('-').map(function(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }).join(' ');
};
var Provider = /*#__PURE__*/ function(RequestClient) {
    _inherits(Provider, RequestClient);
    function Provider(uppy, opts) {
        _class_call_check(this, Provider);
        var _this;
        _this = _call_super(this, Provider, [
            uppy,
            opts
        ]);
        _this.provider = opts.provider;
        _this.id = _this.provider;
        _this.name = _this.opts.name || getName(_this.id);
        _this.pluginId = _this.opts.pluginId;
        _this.tokenKey = "companion-".concat(_this.pluginId, "-auth-token");
        _this.companionKeysParams = _this.opts.companionKeysParams;
        _this.preAuthToken = null;
        return _this;
    }
    _create_class(Provider, [
        {
            key: "headers",
            value: function headers() {
                var _this = this;
                return Promise.all([
                    _get(_get_prototype_of(Provider.prototype), "headers", this).call(this),
                    this.getAuthToken()
                ]).then(function(_ref) {
                    var _$_ref = _sliced_to_array(_ref, 2), headers = _$_ref[0], token = _$_ref[1];
                    var authHeaders = {};
                    if (token) {
                        authHeaders['uppy-auth-token'] = token;
                    }
                    if (_this.companionKeysParams) {
                        authHeaders['uppy-credentials-params'] = btoa(JSON.stringify({
                            params: _this.companionKeysParams
                        }));
                    }
                    return _object_spread({}, headers, authHeaders);
                });
            }
        },
        {
            key: "onReceiveResponse",
            value: function onReceiveResponse(response) {
                response = _get(_get_prototype_of(Provider.prototype), "onReceiveResponse", this).call(this, response); // eslint-disable-line no-param-reassign
                var plugin = this.uppy.getPlugin(this.pluginId);
                var oldAuthenticated = plugin.getPluginState().authenticated;
                var authenticated = oldAuthenticated ? response.status !== 401 : response.status < 400;
                plugin.setPluginState({
                    authenticated: authenticated
                });
                return response;
            }
        },
        {
            key: "setAuthToken",
            value: function setAuthToken(token) {
                return this.uppy.getPlugin(this.pluginId).storage.setItem(this.tokenKey, token);
            }
        },
        {
            key: "getAuthToken",
            value: function getAuthToken() {
                return this.uppy.getPlugin(this.pluginId).storage.getItem(this.tokenKey);
            }
        },
        {
            key: "ensurePreAuth",
            value: /**
   * Ensure we have a preauth token if necessary. Attempts to fetch one if we don't,
   * or rejects if loading one fails.
   */ function ensurePreAuth() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.companionKeysParams && !_this.preAuthToken)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.fetchPreAuthToken()
                                ];
                            case 1:
                                _state.sent();
                                if (!_this.preAuthToken) {
                                    throw new Error('Could not load authentication data required for third-party login. Please try again later.');
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "authUrl",
            value: function authUrl(queries) {
                if (queries === void 0) {
                    queries = {};
                }
                var params = new URLSearchParams(queries);
                if (this.preAuthToken) {
                    params.set('uppyPreAuthToken', this.preAuthToken);
                }
                return "".concat(this.hostname, "/").concat(this.id, "/connect?").concat(params);
            }
        },
        {
            key: "fileUrl",
            value: function fileUrl(id) {
                return "".concat(this.hostname, "/").concat(this.id, "/get/").concat(id);
            }
        },
        {
            key: "fetchPreAuthToken",
            value: function fetchPreAuthToken() {
                var _this = this;
                return _async_to_generator(function() {
                    var res, err;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.companionKeysParams) {
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.post("".concat(_this.id, "/preauth/"), {
                                        params: _this.companionKeysParams
                                    })
                                ];
                            case 2:
                                res = _state.sent();
                                _this.preAuthToken = res.token;
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                _this.uppy.log("[CompanionClient] unable to fetch preAuthToken ".concat(err), 'warning');
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "list",
            value: function list(directory) {
                return this.get("".concat(this.id, "/list/").concat(directory || ''));
            }
        },
        {
            key: "logout",
            value: function logout() {
                var _this = this;
                return this.get("".concat(this.id, "/logout")).then(function(response) {
                    return Promise.all([
                        response,
                        _this.uppy.getPlugin(_this.pluginId).storage.removeItem(_this.tokenKey)
                    ]);
                }).then(function(_ref2) {
                    var _$_ref2 = _sliced_to_array(_ref2, 1), response = _$_ref2[0];
                    return response;
                });
            }
        }
    ], [
        {
            key: "initPlugin",
            value: function initPlugin(plugin, opts, defaultOpts) {
                /* eslint-disable no-param-reassign */ plugin.type = 'acquirer';
                plugin.files = [];
                if (defaultOpts) {
                    plugin.opts = _object_spread({}, defaultOpts, opts);
                }
                if (opts.serverUrl || opts.serverPattern) {
                    throw new Error('`serverUrl` and `serverPattern` have been renamed to `companionUrl` and `companionAllowedHosts` respectively in the 0.30.5 release. Please consult the docs (for example, https://uppy.io/docs/instagram/ for the Instagram plugin) and use the updated options.`');
                }
                if (opts.companionAllowedHosts) {
                    var pattern = opts.companionAllowedHosts; // validate companionAllowedHosts param
                    if (typeof pattern !== 'string' && !Array.isArray(pattern) && !_instanceof(pattern, RegExp)) {
                        throw new TypeError("".concat(plugin.id, ': the option "companionAllowedHosts" must be one of string, Array, RegExp'));
                    }
                    plugin.opts.companionAllowedHosts = pattern;
                } else if (/^(?!https?:\/\/).*$/i.test(opts.companionUrl)) {
                    // does not start with https://
                    plugin.opts.companionAllowedHosts = "https://".concat(opts.companionUrl.replace(/^\/\//, ''));
                } else {
                    plugin.opts.companionAllowedHosts = new URL(opts.companionUrl).origin;
                }
                plugin.storage = plugin.opts.storage || tokenStorage;
            /* eslint-enable no-param-reassign */ }
        }
    ]);
    return Provider;
}(RequestClient);
module.exports = Provider;
